import React, { useMemo } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { Button, Form, Modal } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { deleteBlock } from "../../../redux/JobModule/QCDetailPage/QCDetailPageAction";

interface QcDetailAudioBlockDeleteModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function QcDetailAudioBlockDeleteModal(props: QcDetailAudioBlockDeleteModalProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const idTranscription = useSelector((state: RootState) => state.qCDetailPageState.data.transcriptions[0].idTranscription);
  const idBlock = useSelector((state: RootState) => state.qCDetailPageState.selectedTranscriptionBlock);

  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
  };

  const QcDetailAudioBlockDeleteModalContent = useMemo(() => {
    const onFinish = (value: any) => {
      props.close();
      form.resetFields();
      dispatch(deleteBlock({ idTranscription: idTranscription, idBlock: idBlock }));
    };

    return (
      <div className="d-flex flex-column gap-4 w-100 modal-body-content">
        <h4> Delete Segment</h4>
        <p>Are you sure you want to delete this audio segment?</p>
        <div className="d-flex gap-3 justify-content-end">
          <Button
            style={{ color: "white", background: "#CCOOOO", boxShadow: "none" }}
            className="deleteButton"
            type="primary"
            htmlType="submit"
            onClick={onFinish}>
            Ok
          </Button>

          <Button
            className="cancelButton"
            htmlType="reset"
            onClick={handleModalClose}>
            Cancel
          </Button>
        </div>
      </div>
    );
  }, [form, idTranscription, idBlock]);

  return (
    <div>
      <Modal
        centered
        zIndex={1500}
        footer={[]}
        width={400}
        onCancel={handleModalClose}
        open={props.openState}>
        {QcDetailAudioBlockDeleteModalContent}
      </Modal>
    </div>
  );
}

export default QcDetailAudioBlockDeleteModal;
